import constants from 'shared/src/constants'

export const getReservationPaymentStatus = (reservation) => {
  if(!reservation || !reservation.stripe_payment_data) return 'none'
  if(reservation.stripe_payment_data.status != 'succeeded') {
    return reservation.stripe_payment_data.charges.data.length <= 0 ?
      'none' :
      'waiting'
  }
  if(reservation.status != constants.BOOKING_STATUS_CONFIRMED) return 'waiting'
  return 'confirmed'
}